import { laptopMax, mobileXXLargeMax, tabletMax } from '@propertypal/shared/src/constants/mediaQueries';
import { MAX_WIDTH } from '@propertypal/web-ui/src/layout/PageWrapper.style';
import styled from 'styled-components';
import { IconLink } from './social-links/SocialLinks.style';

export const Container = styled.div`
  background-color: #d9d9d9;
`;

export const Content = styled.div`
  width: 100%;
  max-width: ${MAX_WIDTH}px;
  margin: 0 auto;
  padding: 30px 30px 90px;

  button {
    font-size: 16px;
    color: ${({ theme }) => theme.primary};
    text-align: left;
  }

  button:hover {
    text-decoration: underline;
  }

  a {
    color: ${({ theme }) => theme.textDark};
  }

  a:hover {
    text-decoration: underline;
  }

  p {
    font-size: 14px;
    color: ${({ theme }) => theme.textDark};
  }

  @media (${laptopMax}) {
    padding: 30px 15px 120px;
  }
`;

export const BoxWrapper = styled.div`
  border-bottom: 1px solid ${({ theme }) => theme.backgroundMid};
  padding: 15px 0;

  &:last-child {
    border-bottom: none;
  }

  ${IconLink} img {
    filter: brightness(20%);
  }
  ${IconLink} img:hover {
    filter: invert(44%) sepia(62%) saturate(3918%) hue-rotate(314deg) brightness(94%) contrast(98%);
  }
`;

export const BottomRow = styled.div`
  padding: 15px 0;
  display: flex;
  justify-content: space-between;

  & > div:first-child {
    p {
      margin-top: 10px;
    }
  }

  & > div:last-child {
    display: block;
    text-align: right;
  }

  @media (${mobileXXLargeMax}) {
    flex-direction: column;

    & > div:last-child {
      margin-top: 30px;
      text-align: left;
    }
  }
`;

export const LinkGrid = styled.div`
  border-bottom: 1px solid ${({ theme }) => theme.backgroundMid};
  padding: 15px 0;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;

  @media (${tabletMax}) {
    grid-template-columns: repeat(2, 1fr);
  }
`;
